var render, staticRenderFns
import script from "./FundraisingPageSummary.vue?vue&type=script&lang=js&"
export * from "./FundraisingPageSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abcd4fc",
  null
  
)

export default component.exports